import Logo from "../components/Logo/Logo.js";
import Nav from "../components/Nav/Nav.js";
import csblLogo from "../images/CSBL_Logo.png";
import styled from "styled-components";
import image1 from "../images/paper_fig/Figure_3B.png";
import image2 from "../images/paper_fig/Figure_2.png";
import { Link } from 'react-router-dom';
import { useState } from 'react';

// IMPORTAR O ARQUIVO JSON (Certifique-se de ajustar o caminho conforme onde você salvou)
import studiesData from '../data/v2/studiesData.json';

// COMPONENTES AUXILIARES
function AtlasSummaryContent() {
  return (
    <>
      <p>
        Navigate the multi-organ transcriptomic landscape of severe COVID-19. This interactive tool enables the visualization of gene–tissue connectivity and pathway-level perturbations derived from integrated bulk RNA-seq analyses. Discover conserved biological processes and identify multi-tissue hub genes that orchestrate the systemic immune response.
      </p>

      
      <ul style={{ marginTop: '40px' }}>
        <li>
          <Link to="https://degs.covidatlas.sysbio.tools/"><strong>Network of Consensus DEGs by Tissue</strong></Link>
          <p>Network analysis of the consensus DEGs identified 15 multi-tissue hub genes, including IFITM3, CCR1, BCL2A1, and RAB8B, several of which are implicated in antiviral and immune regulatory processes. The interactive network display enables visualization of gene–tissue connectivity and the distribution of these hubs across organs.</p>
        </li>
        <li style={{ marginTop: '30px' }}>
          <Link to="https://pathways.covidatlas.sysbio.tools/"><strong>Network of Enriched Pathways by Tissue</strong></Link>
          <p>A total of 1,992 enriched biological pathways were identified, encompassing key processes such as inflammatory signaling, TNF-α/NF-κB activation, and neutrophil-mediated immunity. The pathway network module highlights high-degree pathways that may represent central coordinators of the molecular response to severe COVID-19 across multiple tissues.</p>
        </li>
      </ul>
      
        {/* PAINEL DE DESTAQUE */}
        <section className="content-box transition-text" style={{ marginTop: '50px' }}>
            <p>
               Using a network-analysis approach, we observed that organs such as the heart, colon, lymph nodes, and testis exhibited a greater number of DEGs compared to the lung, nasopharyngeal swab, liver, kidney, and brain. In addition, we identified <strong>15 hub genes</strong> that are crucial for understanding the systemic impact of the disease. The network-based strategy also revealed several <strong>tissue-specific processes</strong>, providing deeper insight into the diverse molecular landscape of severe COVID-19.

            </p>
        </section>
    </>
  );
}

// COMPONENTE DO ACORDEÃO (Recebe data como prop, ou usa o importado)
function StudiesAccordion({ data }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="accordion-wrapper">
            <button className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
                {/* Conta dinamicamente o número de estudos */}
                <span>📚 Data Source: List of {data.length + 1} Integrated Studies</span>
                <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>
            </button>
            
            {isOpen && (
                <div className="accordion-content">
                    <table className="studies-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Study Title</th>
                                <th>Link</th>
                                <th>Data Deposited</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((study) => (
                                <tr key={study.id}>
                                    <td>{study.id}</td>
                                    <td>{study.title}</td>
                                    <td>
                                        <a href={study.link} target="_blank" rel="noreferrer">View Paper</a>
                                    </td>
                                    <td>{study.data || "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

// PAGE COMPONENT
export default function HomePage() {
  const mainTitle = "Interactive Network Visualization";

  return (
    <>
      <Nav/>
      <StyledContainer>
        
        {/* HEADER */}
        <header className="main-header-row">
            <Logo src={csblLogo} className={"logo"} />
            <h1 className="main-title-text">{mainTitle}</h1>
        </header>

        {/* SEÇÃO 1: Texto Descritivo */}
        <section className="content-box summary-section">
            <AtlasSummaryContent />
        </section>
        
        {/* SEÇÃO 2: Figura 2 */}
        <section className="image-box center-container">
            <h3 className="figure-title">Discovery of Key Genes Linked to Severe COVID-19</h3>
            <img src={image2}  className="section-image" />
            <p className="figure-caption">
                <strong>A.</strong>  Number of consensus genes identified in bulkRNA-seq data, categorized by tissue. Up-regulated genes are represented in pink, while down-regulated genes are depicted in cyan. <strong>B.</strong>  Hub genes identified through network analysis, where nodes represent consensus genes connected with tissues. Nodes with a degree greater than or equal to 5 are highlighted. Node color indicates the median log2 fold change for each gene in each tissue, with red representing up-regulation and blue representing down-regulation.
            </p>              
        </section>

        {/* SEÇÃO 2: Figura 1 */}
        <section className="image-box center-container">
            <h3 className="figure-title">Unveiling Central and Tissue-Specific Pathways Linked to Severe COVID-19</h3>
            <img src={image1}  className="section-image" />
            <p className="figure-caption">
                Enrichment analysis results illustrate enriched pathways using consensus genes sets identified as common and tissue-specific in severe COVID-19. Pathways are color-coded, with blue indicating downregulation and red indicating upregulation in bulk RNA-seq data. 
            </p>              
        </section>

        

        {/* ACORDEÃO DE DADOS */}
        <section className="accordion-section">
            <StudiesAccordion data={studiesData} />
        </section>

      </StyledContainer>
    </>
  );
}

// ESTILOS CSS
const StyledContainer = styled.div`
    width: 85vw; 
    max-width: 1000px;
    margin: 40px auto 80px auto; 
    font-family: sans-serif; 
    display: flex;
    flex-direction: column;
    gap: 40px; 

    /* REGRA GLOBAL DE NEGRITO */
    strong {
        font-weight: bold; 
    }

    /* HEADER */
    .main-header-row {
        display: flex;
        align-items: center; 
        gap: 20px;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
    }

    .main-title-text {
        margin: 0;
        font-size: 1.8em; 
        color: #333;
        font-weight: 500;
    }
    
    .logo { height: 80px; width: auto; }
    
    /* GERAL */
    .content-box { padding: 16px; border-radius: 6px; }

    /* TEXTO PRINCIPAL */
    .summary-section {
        border: none;
        background-color: transparent;
        font-size: 1.0em;
        line-height: 1.5;
        padding: 10px 16px; 
        text-align: justify;
        hyphens: auto;

        ul {
            list-style-type: none; /* Removemos as bolinhas padrão para focar nos botões */
            margin-left: 10px; 
            padding-left: 0;
            margin-top: 15px;
            margin-bottom: 15px;
        }
        
        li {
            margin-bottom: 15px; /* Mais espaço entre os itens */
            display: block;
        }
        
        /* ESTILO DE LINK APRIMORADO (BOTÃO) */
        a {
            text-decoration: none;
            color: #0d3c61; /* Texto azul escuro */
            background-color: #AFD1FF; 
            padding: 6px 12px;
            border-radius: 20px; /* Bordas mais arredondadas (pílula) parecem mais clicáveis */
            font-weight: bold; 
            display: inline-flex; /* Melhora alinhamento com ícones */
            align-items: center;
            
            border: 1px solid #9dc4f8;
            box-shadow: 0 2px 5px rgba(0,0,0,0.08);
            transition: all 0.2s ease;
        }

        a:hover {
            background-color: #8cbcfc;
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
        }

        /* ÍCONE DE SETA AUTOMÁTICO */
        a::after {
            content: "➜";
            font-size: 0.9em;
            margin-left: 8px;
            transition: transform 0.2s;
        }

        a:hover::after {
            transform: translateX(4px);
        }
    }
    
    /* PAINEL DE DESTAQUE */
    .transition-text {
        text-align: center;
        padding: 20px 40px;
        margin: 20px auto;
        max-width: 800px;
        font-size: 1.05em;
        line-height: 1.6;
        background-color: #F2F2F2; 
        border-radius: 8px; 
        p { margin: 0; }
    }

    /* IMAGENS E LEGENDAS */
    .image-box { border: none; padding: 0; margin: 0; background: transparent; }

    .center-container {
        display: flex;
        flex-direction: column; 
        justify-content: center; 
        align-items: center; 
        width: 100%;
        margin-top: 60px;
    }

    .section-image { width: 100%; height: auto; max-width: 80%; display: block; margin: 0 auto; }
    .reduced-width { max-width: 40% !important; }

    .figure-title {
        font-size: 1.25em;
        font-weight: bold;
        color: #222;
        margin-bottom: 20px;
        text-align: center;
        width: 100%;
    }

    .figure-caption {
        margin-top: 20px;      
        font-size: 0.95rem;     
        color: #444;           
        line-height: 1.5;
        text-align: justify;   
        width: 80%; 
    }

    /* ESTILOS DO ACORDEÃO */
    .accordion-section {
        margin-top: 40px;
        border-top: 1px solid #eee;
        padding-top: 20px;
    }

    .accordion-header {
        background-color: #f9f9f9;
        color: #444;
        cursor: pointer;
        padding: 15px;
        width: 100%;
        border: 1px solid #ddd;
        border-radius: 5px;
        text-align: left;
        outline: none;
        font-size: 1rem;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: background-color 0.2s ease;
    }

    .accordion-header:hover { background-color: #f1f1f1; }

    .arrow { transition: transform 0.2s ease; font-size: 0.8rem; }
    .arrow.open { transform: rotate(180deg); }

    .accordion-content { padding: 10px 0; overflow-x: auto; }

    .studies-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.85rem;
        margin-top: 10px;
    }

    .studies-table th, .studies-table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
    }

    .studies-table th { background-color: #f2f2f2; color: #333; font-weight: bold; }
    .studies-table tr:nth-child(even) { background-color: #fbfbfb; }
    .studies-table tr:hover { background-color: #f1f1f1; }
    
    .studies-table a { color: #0066cc; text-decoration: none; }
    .studies-table a:hover { text-decoration: underline; }

    @media (max-width:600px){
        width: 95%;
        margin: 20px auto;
        
        .main-header-row { flex-direction: column; text-align: center; }
        .figure-caption { text-align: left; width: 100%; }
        .section-image { max-width: 100%; }
        .reduced-width { max-width: 80% !important; }
        .transition-text { padding: 15px; }
    }
`